// Helpers for signing in a top-level window by redirect (the Zendesk iframe
// signs in through the popup instead, see RequestAuth)
const URL_BEFORE_AUTH_KEY = 'url-before-auth';
const SILENT_SIGN_IN_AT_KEY = 'silent-sign-in-at';

// A silent sign-in that succeeds but is followed straight away by another
// session loss (e.g. the API rejecting every token) would otherwise redirect
// in a loop
const SILENT_SIGN_IN_INTERVAL_MS = 60 * 1000;

// Keycloak's answers to prompt=none when the agent has to act: no session
// (login_required), or something to fill in such as a missing phone number
// (interaction_required)
const SIGN_IN_REQUIRED_ERRORS = ['login_required', 'interaction_required'];

function isAuthResponse(search: string): boolean {
  const params = new URLSearchParams(search);

  return params.has('code') || params.has('error');
}

// The redirect URI is the site root, so remember the page to come back to.
// Keycloak's answer also lands on the root: keep the page remembered before it.
export function rememberPageBeforeSignIn(): void {
  if (isAuthResponse(window.location.search)) return;
  sessionStorage.setItem(
    URL_BEFORE_AUTH_KEY,
    `${window.location.pathname}${window.location.search}`
  );
}

export function takePageBeforeSignIn(): string | null {
  const url = sessionStorage.getItem(URL_BEFORE_AUTH_KEY);

  sessionStorage.removeItem(URL_BEFORE_AUTH_KEY);

  return url;
}

export function canTrySilentSignIn(): boolean {
  const lastTry = Number(sessionStorage.getItem(SILENT_SIGN_IN_AT_KEY) || 0);

  return Date.now() - lastTry > SILENT_SIGN_IN_INTERVAL_MS;
}

export function markSilentSignInTried(): void {
  sessionStorage.setItem(SILENT_SIGN_IN_AT_KEY, String(Date.now()));
}

export function isSignInRequiredResponse(search: string): boolean {
  const error = new URLSearchParams(search).get('error');

  return !!error && SIGN_IN_REQUIRED_ERRORS.includes(error);
}
